import React, { Component } from 'react';
import SearchProduct from './SearchProduct';
import { branch } from 'baobab-react/higher-order';
import Header from "../common/Header";

class LocateProductModel extends Component {
    render() {
        return (
            <div>
                <Header
                    title="Set Up and Use"
                    description="Access the product manual, video guides, and more for your safe."
                />
                <section className="section section-locate-product-manual">
                    <div className="section-header row text-center">
                        <div className="col">
                            <h2>Find My Safe</h2>
                            <p>Enter your model number below for product support and registration.
                            <a className="arrow-link" style={{textTransform: "none"}} href="/support/find-your-model-or-serial-number" target="_blank">Can't find your model number?</a>
                            </p>
                            
                        </div>
                    </div>
                    <div className="section-content row">
                        <div className="col">
                            <SearchProduct product={ this.props.product } />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
};

export default branch({
    token: ['token'],
    product: ['product']
}, LocateProductModel);


// WEBPACK FOOTER //
// ./src/pages/aboutMySafe/LocateProductModel.js